interface GetDateMatrixContentMaxWidthArgs {
  leftColumnWidth: number;
  dateColumnCount: number;
  dayColumnWidth: number;
  summaryColumnWidth?: number;
  hasSummaryColumn?: boolean;
}

const getDateMatrixContentWidth = ({
  leftColumnWidth,
  dateColumnCount,
  dayColumnWidth,
  summaryColumnWidth = 0,
  hasSummaryColumn = false
}: GetDateMatrixContentMaxWidthArgs) => {
  return (
    leftColumnWidth +
    dateColumnCount * dayColumnWidth +
    (hasSummaryColumn ? summaryColumnWidth : 0) +
    dateColumnCount +
    (hasSummaryColumn ? 1 : 0) +
    2
  );
};

export const getDateMatrixContentMaxWidth = (args: GetDateMatrixContentMaxWidthArgs) => {
  return getDateMatrixContentWidth(args);
};

export const getDateMatrixContentMinWidth = (args: GetDateMatrixContentMaxWidthArgs) => {
  return getDateMatrixContentWidth(args);
};

export const getDateMatrixContentWidthStyle = ({
  leftColumnWidth,
  dateColumnCount,
  dayColumnMinWidth,
  dayColumnMaxWidth,
  summaryColumnWidth = 0,
  hasSummaryColumn = false
}: {
  leftColumnWidth: number;
  dateColumnCount: number;
  dayColumnMinWidth: number;
  dayColumnMaxWidth: number;
  summaryColumnWidth?: number;
  hasSummaryColumn?: boolean;
}) => {
  return {
    minWidth: `${getDateMatrixContentMinWidth({
      leftColumnWidth,
      dateColumnCount,
      dayColumnWidth: dayColumnMinWidth,
      summaryColumnWidth,
      hasSummaryColumn
    })}px`
  };
};
